import { useStickyBottomBarContext } from "contexts/StickyBottomBarContext";
import { useDeviceSize } from "hooks";
import { ChakraSlide as Slide } from "@airhelp/react-ui-components";
import { useEffect, useRef } from "react";
import { useZowiePositionStore } from "stores/ZowiePositionStore";
import { iconsWithText } from "./StickyBottomBar.config";
import type { StickyBottomBarProps } from "./StickyBottomBar.d";
import StickyBottomBarDesktop from "./StickyBottomBarDesktop";
import StickyBottomBarMobile from "./StickyBottomBarMobile";

const StickyBottomBar = ({ heading, variant }: StickyBottomBarProps) => {
  const { isDesktop } = useDeviceSize();
  const { isOpen } = useStickyBottomBarContext();
  const bottomBarElement = useRef<HTMLDivElement>(null);
  const { setBottom } = useZowiePositionStore();

  useEffect(() => {
    if (!isOpen && !isDesktop) {
      setBottom(0);
      return;
    }
    setBottom(Number(bottomBarElement.current?.clientHeight));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, isDesktop]);

  return (
    <Slide
      in={isOpen}
      direction="bottom"
      style={{ zIndex: 2, transition: ".1s" }}
      data-testid="sticky-bottom-bar"
      ref={bottomBarElement}
    >
      {isDesktop ? (
        <StickyBottomBarDesktop iconsWithText={iconsWithText} heading={heading} variant={variant} />
      ) : (
        <StickyBottomBarMobile iconsWithText={iconsWithText} variant={variant} heading={heading} />
      )}
    </Slide>
  );
};

export default StickyBottomBar;
